const defaultLocale = 'no';
const supportedLocales = ['no', 'en'];
export function getCurrentLanguage() {
    var _a, _b, _c;
    const langAttr = (_c = (_b = (_a = document.getElementsByTagName('html')) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.getAttribute('lang')) !== null && _c !== void 0 ? _c : '';
    if (supportedLocales.includes(langAttr)) {
        return langAttr;
    }
    return defaultLocale;
}
